import ImportHelper from './import.helper'


/*Precondicion: solo un video en la carpeta*/

//const AllTransitions = () => { return ImportHelper.importAll(require.context("../assets/videos/", true, /\.mp4/)); }

export const ContextTransitions = {
    "General View": { initFrame:  80 },
    "Torre 1 - B2 Infinita": { initFrame:  0 },
    "Torre 2 - B4 Inspira": { initFrame:  0 },
    "Parque infantil": { initFrame:  15 },
    "Lobby": { initFrame:  15 },
    "Spa": { initFrame:  90 },
    "Spa para Mascotas": { initFrame:  90 },
    "Salón Infantil": { initFrame:  90 },
    "Salón de Baile": { initFrame:  5 },
    "Cocina Social": { initFrame:  70 },
    "Coworking": { initFrame:  5 },
    "Salón de Juegos": { initFrame:  90 },
    "Salón Social": { initFrame:  8 },
    "Piscina": { initFrame:  2 },
    "Gimnasio": { initFrame:  95 },

    //"EveryTransition": { importTransition: AllTransitions }
}
